import * as XLSX from 'xlsx-js-style';

const STATUS_MAP = {
	0: 'Suspended',
	1: 'Active',
	2: 'Terminated',
	3: 'Blocked',
};

const getHeaderLabel = (column) => {
	if (typeof column?.label === 'string') {
		return column.label;
	}

	// Support labels rendered via React components like <LabelWithCurrencySign text='Cost/h/' />.
	if (column?.label?.props?.text) {
		return column.label.props.text;
	}

	return column?.field || '';
};

const getObjectText = (value) => {
	if (!value || typeof value !== 'object') {
		return value;
	}

	if (typeof value.name === 'string' && typeof value.surname === 'string') {
		return `${value.name} ${value.surname}`.trim();
	}

	if (typeof value.name === 'string') {
		return value.name;
	}

	if (typeof value.title === 'string') {
		return value.title;
	}

	if (typeof value.label === 'string') {
		return value.label;
	}

	if (typeof value.value === 'string' || typeof value.value === 'number') {
		return value.value;
	}

	if (typeof value.id === 'number' || typeof value.id === 'string') {
		return value.id;
	}

	return JSON.stringify(value);
};

const getCellValue = (row, field) => {
	if (!row || !field) {
		return '';
	}

	if (field === 'status') {
		if (typeof row.status === 'string') {
			return row.status;
		}

		return STATUS_MAP[row.status] || `${row.status ?? ''}`;
	}

	if (field === 'active_timer') {
		return row.active_timer?.id ? 'Yes' : 'No';
	}

	if (field === 'cost' || field === 'sallary') {
		return row.profitability?.[field] ?? '';
	}

	const value = row[field];

	if (Array.isArray(value)) {
		return value.map((item) => getObjectText(item)).filter(Boolean).join(', ');
	}

	if (value && typeof value === 'object') {
		return getObjectText(value);
	}

	if (value === null || typeof value === 'undefined') {
		return '';
	}

	return value;
};

const applyHeaderStyles = (worksheet, columnCount) => {
	for (let index = 0; index < columnCount; index += 1) {
		const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
		if (worksheet[cellAddress]) {
			worksheet[cellAddress].s = {
				font: {
					bold: true,
				},
			};
		}
	}
};

export const generateExcelExport = (columns = [], data = []) => {
	const exportColumns = columns.filter(
		(column) => column?.checked && column?.field && column.field !== 'photo' && column.field !== 'avatar',
	);

	if (!exportColumns.length) {
		return;
	}

	const rows = (Array.isArray(data) ? data : []).map((row) => {
		return exportColumns.reduce((acc, column) => {
			const header = getHeaderLabel(column);
			acc[header] = getCellValue(row, column.field);
			return acc;
		}, {});
	});

	const worksheet = XLSX.utils.json_to_sheet(rows);
	applyHeaderStyles(worksheet, exportColumns.length);
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, 'Employees');

	const datePart = new Date().toISOString().slice(0, 10);
	XLSX.writeFile(workbook, `employees-${datePart}.xlsx`);
};